import { Component, Input, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { distinctUntilChanged, filter, map } from 'rxjs/operators'

@Component({
    selector: 'mg-preview-model-3',
    templateUrl: './preview-model-3.component.html',
    styleUrls: ['./preview-model-3.component.scss'],
})
export class PreviewModel3Component implements OnInit {
    @Input() influencingValues$: Observable<{ [optionName: string]: { id: string; label: string } }>

    activePath$: Observable<string>

    ngOnInit() {
        this.activePath$ = this.influencingValues$.pipe(
            map(({ edition, paint, rims }) => this.getImageUrl(edition.label, paint.label, rims.label)),
            filter(activePath => this.carsUrls.map(({ path }) => path).includes(activePath)),
            distinctUntilChanged()
        )
    }

    carsUrls = [
        { path: 'ultrared-18-longrange' },
        { path: 'ultrared-19-longrange' },
        { path: 'ultrared-20-performance' },

        { path: 'white-18-longrange' },
        { path: 'white-19-longrange' },
        { path: 'white-20-performance' },

        { path: 'deepbluemetallic-18-longrange' },
        { path: 'deepbluemetallic-19-longrange' },
        { path: 'deepbluemetallic-20-performance' },

        { path: 'solidblack-18-longrange' },
        { path: 'solidblack-19-longrange' },
        { path: 'solidblack-20-performance' },

        { path: 'midnightsilver-18-longrange' },
        { path: 'midnightsilver-19-longrange' },
        { path: 'midnightsilver-20-performance' },

        { path: 'stealthgrey-19-longrange' },
        { path: 'stealthgrey-18-longrange' },
        { path: 'stealthgrey-20-performance' },
    ]

    translatePaint(paint): string {
        switch (paint) {
            case 'Pearl White Multi-Coat':
                return 'white'
            case 'Deep Blue Metallic':
                return 'deepbluemetallic'
            case 'Midnight Silver Metallic':
                return 'stealthgrey'
            case 'Multi-Coat Red':
                return 'ultrared'
            case 'Ultra Red':
                return 'ultrared'
            case 'Solid Black':
                return 'solidblack'
            case 'Stealth Grey':
                return 'stealthgrey'
            default:
                return ''
        }
    }

    translateRims(rims): string {
        switch (rims.trim()) {
            case '18" Aero Wheels':
            case '18" Photon Wheels':
            case "18'' Photon Wheels":
                return '18'
            case '19" Sport Wheels':
            case '19" Nova Wheels':
            case "19'' Nova Wheels":
                return '19'
            case '20" Gray Performance Wheels':
            case '20" Performance Wheels':
            case '20" Überturbine Wheels':
            case '20’’ Überturbine Wheels':
            case '20" Warp Wheels':
                return '20'
            default:
                return '18'
        }
    }
    translateEdition(edition): string {
        switch (edition) {
            case 'Long-Range Dual Motor AWD':
                return 'longrange'
            case 'Performance AWD':
                return 'performance'
            default:
                return 'longrange'
        }
    }

    getImageUrl(edition, paint, rims): string {
        return `${this.translatePaint(paint)}-${this.translateRims(rims)}-${this.translateEdition(edition)}`
    }
}
